<template>
  <div class="edit-video-box">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="400px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="params" :rules="rules" label-width="100px">
        <el-form-item label="城市名:" prop="city">
          <el-input
            v-model="params.city"
            :disabled="type === 'edit'"
            size="small"
            placeholder="请输入城市名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="省:" prop="province">
          <el-input
            v-model="params.province"
            size="small"
            placeholder="请输入省名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="排序:" prop="sortKey">
          <el-input
            v-model.number="params.sortKey"
            size="small"
            placeholder="请输入城市排序"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态:">
          <el-switch v-model="params.enable"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button
          type="primary"
          @click="submitForm('form')"
          :loading="flag"
          size="small"
          >确 认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from "@/api";
import { validatorIndex } from "@/utils/validator";
export default {
  data() {
    return {
      title: "",
      dialogVisible: false,
      flag: false,
      type: "",
      id: "",
      params: {
        city: "",
        province: "",
        sortKey: "",
        enable: false
      },
      // 验证规则
      rules: {
        city: [{ required: true, message: "请输入标签名称", trigger: "blur" }],
        province: [{ required: true, message: "请输入标签名称", trigger: "blur" }],
        sortKey: [
          { required: true, message: "请输入排序", trigger: "blur" },
          { validator: validatorIndex, trigger: "blur" }
        ]
      }
    };
  },

  methods: {
    // 数据提交验证
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.flag = true;
          if (this.type === "add") {
            this.addCity();
          } else {
            this.editCity();
          }
        } else {
          return false;
        }
      });
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.$refs.form.resetFields();
      this.params = {
        sortKey: 0,
        city: "",
        province: "",
        enable: false
      };
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(type, data) {
      this.dialogVisible = true;
      this.type = type;
      if (type === "edit") {
        this.title = "编辑城市";
        this.params.sortKey = data.sortKey;
        this.params.city = data.city;
        this.params.province = data.province;
        this.params.enable = data.enable;
        this.id = data.id;
      } else {
        this.title = "新增城市";
      }
    },
    // 新增热门城市
    addCity() {
      API.addHotCity(this.params)
        .then(res => {
          if (res.code === 200) {
            this.$message({
              message: "新增成功！",
              type: "success"
            });
            this.$emit("handlerCity");
          } else {
            this.$message.error("新增失败！");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.flag = false;
          this.handleClose();
        });
    },
    // 编辑热门城市
    editCity() {
      this.params = Object.assign(this.params, { targetID: this.id });
      API.editHotCity(this.params)
        .then(res => {
          if (res.code === 200) {
            this.$message({
              message: "编辑成功！",
              type: "success"
            });
            this.$emit("handlerCity");
          } else {
            this.$message.error("编辑失败！");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.flag = false;
          this.handleClose();
        });
    }
  }
};
</script>

<style lang="scss" >
.edit-video-box {
  .el-input {
    width: 150px;
  }
  .avatar-uploader {
    width: 150px;
    height: 150px;
  }
  .el-upload {
    width: 100%;
    height: 100%;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover {
      border: 1px dashed #e63765;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
    &:hover {
      color: 1px dashed #e63765 !important;
    }
  }
}
</style>
